import { useNavigate } from 'react-router-dom'
import { Icon } from './Layout'
import { normalizeTag } from '../utils/hashtags'

function TrendingRowSkeleton() {
  return (
    <div className="flex flex-col gap-1.5 animate-pulse">
      <div className="h-2 bg-on-background/10 w-20" />
      <div className="h-3 bg-on-background/10 w-36" />
      <div className="h-2 bg-on-background/10 w-12" />
    </div>
  )
}

export default function TrendingModal({ topics, loading, onClose }) {
  const navigate = useNavigate()

  const handleHashtagClick = (hashtag) => {
    onClose?.()
    navigate(`/hashtag/${encodeURIComponent(normalizeTag(hashtag))}`)
  }

  return (
    <div className="fixed inset-0 z-[70] flex items-end justify-center" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-on-background/60" onClick={onClose} />

      <div
        className="relative w-full max-h-[75vh] bg-surface border-t-[4px] border-x-0 border-b-0 border-on-background rounded-t-2xl overflow-hidden flex flex-col"
        style={{ boxShadow: '0px -4px 0px 0px var(--neo-shadow-color)' }}
      >
        {/* Drag handle */}
        <div className="flex justify-center pt-2">
          <div className="w-10 h-1.5 bg-on-background/20 rounded-full" />
        </div>

        <div className="flex items-center justify-between px-5 pt-3 pb-4 border-b-[3px] border-on-background">
          <h2 className="font-bold text-[13px] uppercase tracking-[0.14em] text-on-surface flex items-center gap-2">
            <Icon name="local_fire_department" className="text-[20px] text-primary" filled />
            Trending
          </h2>
          <button
            onClick={onClose}
            aria-label="Close trending"
            className="w-8 h-8 flex items-center justify-center text-on-surface-variant hover:text-on-surface"
          >
            <Icon name="close" className="text-[20px]" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-5 flex flex-col gap-4">
          {loading ? (
            <>
              <TrendingRowSkeleton />
              <TrendingRowSkeleton />
              <TrendingRowSkeleton />
              <TrendingRowSkeleton />
            </>
          ) : !topics?.length ? (
            <p className="text-[12px] text-on-surface-variant/50 font-mono text-center py-10">
              Nothing trending yet
            </p>
          ) : (
            topics.map((topic) => (
              <button
                key={topic.id}
                onClick={() => handleHashtagClick(topic.hashtag)}
                className="text-left w-full hover:opacity-80 transition-opacity border-b border-on-background/10 pb-3 last:border-b-0 last:pb-0"
              >
                <p className="text-[11px] text-primary font-bold font-mono mb-0.5">{topic.hashtag}</p>
                <p className="font-bold text-on-surface text-[14px]">{topic.title}</p>
                <p className="text-[10px] text-on-surface-variant font-mono">{topic.postCount} Posts</p>
              </button>
            ))
          )}
        </div>

        {/* Safe-area padding for devices with a home indicator */}
        <div className="h-4" />
      </div>
    </div>
  )
}